var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mds-masthead__inner language-selector"},[_c('div',{staticClass:"mds-masthead__right"},[_c('a',{on:{"click":function($event){return _vm.changeLanguage('en')}}},[_vm._v("EN")]),_vm._v(" "),_c('a',{on:{"click":function($event){return _vm.changeLanguage('sp')}}},[_vm._v("SP")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63d8f760","hasScoped":true,"transformToRequire":{"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguageChanger.vue
// module id = Z0hP
// module chunks = 1